import IMPSBaseModel from './imps-base-model';
import { ServiceResult } from './service-result';

export enum PatientPortalDataType {
    // Appointment
    VisitReason = 'VisitReason',

    // Patient information
    PatientPhoneNumber = 'PatientPhoneNumber',
    PatienEmergencyContact = 'PatienEmergencyContact',
    PatientInsurance = 'PatientInsurance',
    PatientPharmacy = 'PatientPharmacy',

    // Medical information
    Allergy = 'Allergy',
    DrinkingHistory = 'DrinkingHistory',
    DrugAbuseHistory = 'DrugAbuseHistory',
    FamilyHistory = 'FamilyHistory',
    FallHistory = 'FallHistory',
    Medication = 'Medication',
    PastMedicalHistory = 'PastMedicalHistory',
    SmokingHistory = 'SmokingHistory',
    SocialHistory = 'SocialHistory',
    VitalSign = 'VitalSign'
}

export enum PatientPortalDataStatus {
    Accepted = 'Accepted',
    Pending = 'Pending',
    Rejected = 'Rejected'
}

export enum PatientPortalDataAction {
    Created = 'Created',
    Deleted = 'Deleted',
    Updated = 'Updated'
}

export class PatientPortalData extends IMPSBaseModel {
    appointmentId: Undefinable<number>;
    relatedId: Undefinable<string>;
    type: PatientPortalDataType;
    status: PatientPortalDataStatus;
    action: PatientPortalDataAction;
    metadata: string;
    dataModel: Object;

    createdDate: string;

    relatedCreatedDate: string;
}

export type PatientPortalDataListResult = ServiceResult<PatientPortalData[]>;
